import ZonePricetype from './ZonePricetype';
import dom from '../../utils/dom';
import CustomAmountInput from './CustomAmountInput';
import FormFieldsComponent from './components/FormFieldsComponent';
import DataAttributes from '../../forms/DataAttributes';

class EditableZonePriceType extends ZonePricetype {
  /**
   * @param {HTMLElement} $el
   */
  constructor($el) {
    super($el);

    this.$select.addEventListener('change', this.onQuantityChange);

    const $amountControlGroup = dom.findFrom($el, `.tn-ticket-selector__amount-input-container [${DataAttributes.ControlGroupFor}]`);

    this.amountInput = new CustomAmountInput($amountControlGroup);
  }

  onQuantityChange = () => {
    this.emit('quantity-change');
  };

  onAmountChange = () => {
    this.emit('price-change');
  };

  onPriceUpdate = () => {
    const { isValid, isEmpty, isMinimumAmountMet } = this.amountInput.getValue();
    const AmountToken = '{:Amount}';

    let errorMessage;

    if (!isValid) {
      errorMessage = FormFieldsComponent.decimalValidationMessage;
    }

    if (isValid && !isEmpty && !isMinimumAmountMet) {
      errorMessage = FormFieldsComponent.contributionMinimumValidationMessage.replace(AmountToken, this.amountInput.minimumAmountFormatted);
    }

    if (errorMessage) {
      this.amountInput.clearErrors();
      this.amountInput.showError(errorMessage);
    } else {
      this.amountInput.clearErrors();
    }

    this.onAmountChange();
  };

  validate() {
    this.onPriceUpdate();
  }

  getIsSelectionValid() {
    const amount = this.amountInput.getValue();
    const quantity = this.getQuantity();

    if (quantity > 0) {
      return !amount.isEmpty && amount.isValid;
    }

    if (quantity === 0) {
      return amount.isEmpty;
    }

    return false;
  }

  /** @returns {import('./TicketSelector').PriceTypeQuantity} */
  getData() {
    const { isValid, rawValue } = this.amountInput.getValue();

    const price = isValid ? rawValue : '';

    return {
      pricetypeId: this.id,
      isUserPrice: true,
      price,
      quantity: this.getQuantity(),
      description: this.description,
    };
  }

  destroy() {
    this.removeAllListeners();

    this.$select.removeEventListener('change', this.onQuantityChange);
  }
}

export default EditableZonePriceType;
